import React, { useState } from 'react';
import LocalizedMessage from 'react-l10n';
import moment from 'moment';
import ReactTableWrapper from '../../ReactTableWrapper';

function ReferralCouponList(props) {
    const { isLoading, list } = props;

    /**
     * Get the React Table props
     *
     * @returns {{list: {columns: *[], showPagination: boolean}}}
     */
    const getTableProps = () => {
        // const lessThanMD = wWidth < breakpoints.md;
        const tableProps = {
            list: {
                columns: [
                    {
                        Header: () => {
                            return (
                                <>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage
                                            id={'REFERRAL_COUPON_CODE'}
                                        />
                                    </span>
                                </>
                            );
                        },
                        Cell: (row) => {
                            return (
                                <>
                                    <span className='react-table__info'>
                                        {row.value}
                                    </span>
                                </>
                            );
                        },
                        headerClassName: 'rt-referral-coupon-list__code',
                        className: 'rt-referral-coupon-list__code',
                        minWidth: undefined,
                        sortable: false,
                        accessor: 'InternalItemID',
                    },
                    {
                        Header: () => {
                            return (
                                <>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage
                                            id={'REFERRAL_COUPON_WHOLESALER'}
                                        />
                                    </span>
                                </>
                            );
                        },
                        Cell: (row) => {
                            return (
                                <>
                                    <span className='react-table__info'>
                                        {row.value}
                                    </span>
                                </>
                            );
                        },
                        headerClassName:
                            'rt-referral-coupon-list__code hidden-xs',
                        className: 'rt-referral-coupon-list__code hidden-xs',
                        minWidth: undefined,
                        sortable: false,
                        accessor: 'OwnedBy.BusinessName',
                    },
                    {
                        Header: () => {
                            return (
                                <>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage
                                            id={'REFERRAL_COUPON_DISCOUNT'}
                                        />
                                    </span>
                                </>
                            );
                        },
                        Cell: (row) => {
                            return (
                                <>
                                    <span className='react-table__info'>
                                        {row.value}%
                                    </span>
                                </>
                            );
                        },
                        headerClassName: 'rt-referral-coupon-list__discount',
                        className: 'rt-referral-coupon-list__discount',
                        minWidth: undefined,
                        sortable: false,
                        accessor: 'Discount',
                    },
                    {
                        Header: () => {
                            return (
                                <>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage
                                            id={'REFERRAL_COUPON_PAYOUT'}
                                        />
                                    </span>
                                </>
                            );
                        },
                        Cell: (row) => {
                            return (
                                <>
                                    <span className='react-table__info'>
                                        {row.value}%
                                    </span>
                                </>
                            );
                        },
                        headerClassName: 'rt-referral-coupon-list__usage',
                        className: 'rt-referral-coupon-list__usage',
                        minWidth: undefined,
                        sortable: false,
                        accessor: 'Commission',
                    },
                    {
                        Header: () => {
                            return (
                                <>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage
                                            id={'REFERRAL_COUPON_EXPIRY'}
                                        />
                                    </span>
                                </>
                            );
                        },
                        Cell: (row) => {
                            const momentDate = moment(row.value, 'YYYY-MM-DD');

                            return (
                                <>
                                    <span className='react-table__info'>
                                        {momentDate
                                            ? momentDate.format('DD MMM YYYY')
                                            : '-'}
                                    </span>
                                </>
                            );
                        },
                        headerClassName: 'rt-referral-coupon-list__expiry',
                        className: 'rt-referral-coupon-list__expiry',
                        minWidth: undefined,
                        sortable: false,
                        accessor: 'Expiry',
                    },
                    {
                        Header: () => {
                            return (
                                <>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage id={'USAGE'} />
                                    </span>
                                </>
                            );
                        },
                        Cell: (row) => {
                            return (
                                <>
                                    <span className='react-table__info'>
                                        {row.value}
                                    </span>
                                </>
                            );
                        },
                        headerClassName: 'rt-referral-coupon-list__usage',
                        className: 'rt-referral-coupon-list__usage',
                        minWidth: undefined,
                        accessor: 'Usage',
                        sortable: false,
                    },
                    {
                        expander: true,
                        Expander: ({ isExpanded, ...rest }) => {
                            return (
                                <>
                                    <button
                                        type='button'
                                        className='react-table__extra-data-toggle'
                                    >
                                        <span className='icon icon-chevron-thick' />
                                    </button>
                                </>
                            );
                        },
                        headerClassName: 'hidden',
                        className: 'hidden',
                        width: 45,
                        sortable: false,
                        accessor: 'ID',
                    },
                ],
                showPagination: false,
            },
        };

        return tableProps;
    };

    return (
        <ReactTableWrapper
            loading={isLoading}
            data={list}
            reactTable={getTableProps()}
        />
    );
}

export default ReferralCouponList;
